import Vue from "vue";
import Router from "vue-router";
import store from "./module/store";
import course from "./module/course";
import user from "./module/user";
import setting from "./module/setting";
import deal from "./module/deal";
import content from "./module/content";
import analysis from "./module/analysis";
import purchase from "./module/purchase";
import notice from "./module/notice";
import library from "./module/library";

Vue.use(Router);

//在路由跳转的时候同一个路由多次添加是不被允许的
//重写路由的replace方法
const routerReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return routerReplace.call(this, location).catch(error => error);
};
//重写路由的push方法
const originalPush = Router.prototype.push;
Router.prototype.push = function(location) {
  return originalPush.call(this, location).catch(error => error);
};

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: "/",
      redirect: "/index"
    },
    {
      path: "/",
      component: () => import("@/components/Home.vue"),
      children: [
        {
          path: "/index",
          name: "Index",
          component: () => import("@/pages/index/Index.vue"),
          meta: {
            title: "概况总览",
            requireAuth: true
          }
        },
        ...notice,
        ...content,
        ...store,
        ...course,
        ...user,
        ...deal,
        ...analysis,
        ...setting,
        ...purchase,
        ...library
      ]
    },
    {
      path: "/undefined",
      name: "Undefined",
      component: () => import("@/pages/undefined/Undefined.vue"),
      meta: {
        title: "404"
      }
    },
    {
      path: "/authority",
      name: "Authority",
      component: () => import("@/pages/undefined/Authority.vue"),
      meta: {
        title: "403"
      }
    },
    {
      path: "/login",
      name: "Login",
      component: () => import("@/pages/login/Login.vue"),
      meta: {
        title: "登录"
      }
    },
    {
      path: "/register",
      name: "Register",
      component: () => import("@/pages/login/Register.vue"),
      meta: {
        title: "商户注册"
      }
    },
    {
      path: "/forget",
      name: "Forget",
      component: () => import("@/pages/login/Forget.vue"),
      meta: {
        title: "找回密码"
      }
    },
    {
      path: "/shop",
      name: "ShopList",
      component: () => import("@/pages/shop/ShopList.vue"),
      meta: {
        title: "店铺列表",
        requireAuth: true
      }
    },
    {
      path: "/creates",
      name: "CreateShop",
      component: () => import("@/pages/shop/CreateShop.vue"),
      meta: {
        title: "创建店铺",
        requireAuth: true
      }
    },
    {
      path: "/play",
      name: "Play",
      component: () => import("@/components/txPlayHtml.vue"),
      meta: {
        title: "视频播放",
        requireAuth: true
      }
    },
    {
      path: "/playAudio",
      name: "PlayAudio",
      component: () => import("@/components/txPlayAudio.vue"),
      meta: {
        title: "音频播放",
        requireAuth: true
      }
    },
    {
      path: "/design",
      name: "Design",
      component: () => import("@/pages/store/setting/view/design/Design.vue"),
      meta: {
        title: "店铺装修",
        requireAuth: true,
        authority: "store:setting"
      }
    },
    {
      path: "/account",
      name: "Account",
      component: () => import("@/pages/account/Account.vue"),
      meta: {
        title: "账号设置",
        requireAuth: true
      }
    },
    {
      path: "*",
      redirect: "/undefined"
    },
    {
      path: "/wxpay",
      name: "WxPay",
      component: () => import("@/components/wxpay/WxPay.vue"),
      meta: {
        title: "服务订购"
      }
    },
    {
      path: "/registerBetaweapp",
      name: "RegisterBetaMiniProgram",
      component: () => import("@/components/weapp/RegisterBetaMiniProgram.vue"),
      meta: {
        title: "创建试用小程序"
      }
    }
  ],
  scrollBehavior(to, from, savePosition) {
    if (savePosition) {
      return savePosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js